<template>
  <div class="animated fadeIn systemcss">
    <div class="row">
      <div class="col-sm-12">
        <b-card>
          <div slot="header">
            <strong>{{$t('NEWSITEPROP')}}</strong>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('KEY')">
                <inputvalidation :formerror="formError" name="key"><b-form-input type="text" v-model="formData.key" v-bind:placeholder="$t('KEY')"></b-form-input></inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('VALUE')">
                <inputvalidation :formerror="formError" name="value"><b-form-input type="text" v-model="formData.value" v-bind:placeholder="$t('VALUE')"></b-form-input></inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
              <b-button type="submit" class="btn button-save" v-on:click.prevent="saveRow(formData)">{{$t('SUBMIT')}}</b-button>
            </div>
          </div>
        </b-card>
      </div><!--/.col-->
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
               <strong>{{$t('SITEPROPS')}}</strong>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('SEARCH')">
                    <b-form-input v-model="pagination.query"></b-form-input>
                  </b-form-fieldset>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="typeof data.root == 'undefined' || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="card-body" v-if="typeof data.root != 'undefined' && data.root.length">
              <table class="table table-responsive-sm table-striped table-logoped">
                <thead>
                  <tr>
                    <th>{{$t('KEY')}}</th>
                    <th>{{$t('VALUE')}}</th>
                    <th>{{$t('SAVE')}}</th>
                    <th>{{$t('DELETE')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in data.root">
                    <td><b-form-input type="text" v-model="item.key"></b-form-input></td>
                    <td><b-form-input type="text" v-model="item.value"></b-form-input></td>
                    <td><b-button type="reset" class="btn button-save" v-on:click.prevent="saveRow(item)"><icon icon="save"></icon> {{$t('SAVE')}}</b-button></td>
                    <td><b-button type="reset" class="btn button-dlt" v-on:click.prevent="deleteRow(item.key)"><icon icon="ban"></icon> {{$t('DELETE')}}</b-button></td>
                  </tr>
                </tbody>
              </table>
              <nav>
                <b-pagination align="center" :total-rows="parseInt(data.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
              </nav>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Api from '@/api/admin/SiteProps'

export default {
  name: 'SiteProps',
  data: function()
  {
    return {
      data: {},
      formError: {},
      formData:
      {
        key: '',
        value: ''
      },
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 20,
        searchTimeout: false
      }
    }
  },
  created: function()
  {
    var me = this;
    me.getData();
  },
  methods:
  {
    saveRow: function(item)
    {
      var me = this;

      if(typeof item.langId != 'undefined')
      {
        item.id = item.langId;
        delete(item.langId);
      }

      Api.save(item, function(val)
      {
        if(val.error)
        {
          me.$notify.notice(val);
          me.formError = val;
        }
        else
        {
          me.$notify.notice(val);
          me.formError = {};
          me.getData();
        }
      })
    },
    getData: function()
    {
      var me = this;
      Api.selectRow(me.getParams, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }
        me.data = data;
      });
    },
    deleteRow: function(id)
    {
      var me = this;
      me.$store.commit('setModalAlert',
      {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function()
        {
          Api.deleteRow({id: id}, function(data)
          {
            me.$notify.notice(data);
            me.getData();
          })
        }
      })
    }
  },
  watch:
  {
    'pagination.currentPage': function(val)
    {
      var me = this;
      me.getData();
    },
    'pagination.query': function(val)
    {
      var me = this;

      if(me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

      me.pagination.searchTimeout = setTimeout(function()
      {
        me.getData();
        me.pagination.searchTimeout = false;
      }, 300);
    }
  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.pagination, {});
      data.start = (data.currentPage-1)*data.limit;
      return data;
    }
  }
}
</script>
